import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    AsumsiIcon,
    IColumnProps, Table, Tooltip, Confirm
} from 'asumsi-components';
import moment from "moment";

export default function (props: any) {
    const { dataSource, metaData, onTableChange, loading } = props;
    const [showConfirmation, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(false);

    const showConfirm = async (e: any) => {
        e.preventDefault();
        setDeleteId(e.target.id);
        setShowConfirm(true);
    };

    const columns: IColumnProps[] = [
        {
            dataIndex: 'no',
            key: 'no',
            title: 'No',
            textAlign: "left",
            alignData: "left",
            columnWidht: "5%",
            render: (text: string, record: any, index: number) => index + 1
        },
        {
            dataIndex: 'name',
            key: 'name',
            title: 'Name',
            sorter: true,
        },
        {
            dataIndex: 'desc',
            key: 'desc',
            title: 'Description',
            sorter: true,
        },
        {
            dataIndex: 'createdAt',
            key: 'createdAt',
            title: 'Created Date',
            columnWidht: "10%",
            render: (text: string) => moment(text).format('DD MMM YYYY HH:MM')
        },
        {
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            title: 'Updated Date',
            columnWidht: "10%",
            render: (text: string) => moment(text).format('DD MMM YYYY HH:MM')
        },
        {
            dataIndex: 'active',
            key: 'active',
            title: 'Status',
            columnWidht: "8%",
            render: (text: string, record: any) => record.active == true ? 'Active' : 'Inactive'
        },
        {
            dataIndex: 'action',
            key: 'action',
            render: (text: string, record: any) => {
                return (
                    <div className="bt-table__action">
                        <Tooltip text="edit">
                            <Link to={`/user/role-groups/form/${record.id}`} style={{ marginRight: "8px" }}>
                                <AsumsiIcon icon="annotation" />
                            </Link>
                        </Tooltip>
                        <Tooltip text="hapus">
                            <Link to="" style={{ marginRight: "5px" }}>
                                <AsumsiIcon id={record.id} onClick={showConfirm} icon="trash" />
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
            columnWidht: "8%",
            title: 'Action',
        },
    ];

    return (
        <Fragment>
            <Table columns={columns}
                dataSource={dataSource}
                className="asumsi-table"
                loading={loading}
                pagination={{
                    currentPage: metaData ? metaData.page : 1,
                    defaultPageSize: metaData ? metaData.limit : defaultPageSize,
                    pageSizeOptions,
                    showSizeChanger,
                    total: metaData ? metaData.totalRecords : 0,
                }}
                rowKey="id"
                onChange={onTableChange}
                upperCaseTitle={true}
            ></Table>
            <Confirm
                loading={loading}
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    await props.deleteData(deleteId);
                    props.fetchDataList();
                }}
                content='Are you sure you want to delete this item?'
                title='Konfirmasi'
                okText='Delete'
            />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/role-groups/libraries/table.tsx